
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortName]",
      function () {
        return require("private-next-pages/[shortName]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortName]"])
      });
    }
  